import { render, staticRenderFns } from "./album_item.vue?vue&type=template&id=0e9a1a4e&"
import script from "./album_item.vue?vue&type=script&lang=js&"
export * from "./album_item.vue?vue&type=script&lang=js&"
import style0 from "./album_item.vue?vue&type=style&index=0&id=0e9a1a4e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports